import config from '@config';

export const PRODUCTION_PUBLIC_PROPOSAL_BASE_URL = 'https://admin.clarke.com.br';
export const BETA_PUBLIC_PROPOSAL_BASE_URL = 'https://beta-admin.clarke.com.br';

export const getPublicProposalBaseUrl = (): string =>
  String(config.IS_IN_PRODUCTION) === 'true' ? PRODUCTION_PUBLIC_PROPOSAL_BASE_URL : BETA_PUBLIC_PROPOSAL_BASE_URL;

export const buildPublicProposalUrl = (pathWithQuery: string): string => {
  const normalizedPath = pathWithQuery.startsWith('/') ? pathWithQuery : `/${pathWithQuery}`;
  return `${getPublicProposalBaseUrl()}${normalizedPath}`;
};
